import React, { useEffect, useState } from 'react';
import './AllForMultiVideo.scss';
import '../common.scss';
import { IComponentMultiVideo } from '../../component';
import useTheme from '../hooks/useTheme';
import { style } from '../../utils/image';
import classNames from 'classnames';
import { getGalleryStatus, getScrollCls } from '../../utils/util';
import AllForVideoH from '../ComponentVideoH/AllForVideoH';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';

interface IAllForMultiVideo extends IComponentMultiVideo {
  rootStore?: RootStore;
}

function AllForMultiVideo(props: IAllForMultiVideo) {
  const theme = useTheme();
  const { title, video_list: list } = props;
  // console.log('AllForMultiVideo' ,list);

  const [activeIndex, setActiveIndex] = useState(0);

  const switchVideo = function(index: number) {
    setActiveIndex(index);
  };
  if (!list.length) {
    console.warn('AllForMultiVideo 当前没有列表', list);
    return null;
  }

  const video_id = list[activeIndex].id;
  return (
    <div className={'all-for-multi-video decoratev2-comp-com'}>
      <div className="row-wrapper" style={{ color: theme.h1Color }}>
        {title && (
          <p className="title" style={{ color: theme.h1Color }}>
            {title}
          </p>
        )}

        {list[activeIndex] && (
          <AllForVideoH
            wrapperStyle={{ borderRadius: 10 }}
            danmuku={false}
            video_id={video_id}
            notice={false}
            {...props}
          />
        )}

        <div className={classNames('video-list', getScrollCls())}>
          {list.map((one, index) => {
            // const [statusName, statusColor] = getGalleryStatus(one.status);
            return (
              <div
                className={'list-one'}
                key={index}
                onClick={() => switchVideo(index)}
              >
                <img
                  src={style(one.thumb, 'wx_750_420')}
                  className={'one-photo'}
                  style={
                    activeIndex === index
                      ? { borderColor: theme.mainColor }
                      : {}
                  }
                />
                <div className={'one-name'}>{one.desc}</div>
                {activeIndex === index && (
                  <img
                    className={'icon-playing'}
                    src={require('../../assets/icon-playing.gif')}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
export default inject('rootStore')(observer(AllForMultiVideo));
